import React from 'react'
import { Dialog } from '@material-ui/core'
import GeneralDialogTemplate from '../glueos-components/general-dialog-template'

// const useStyles = makeStyles(theme => ({
//   root: {
//     width: '640px',
//     height: '424px'
//   }
// }), { name: 'MuiGlueForgotPasswordDialog' })

const ErrorDialog = (props) => {
  // const classes = useStyles()

  return (
    <Dialog
      open={!!props.open}
      maxWidth={false}
    >
      <GeneralDialogTemplate header={props.header} body={props.body} callbacks={props.callbacks} image='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/ErrorIcon_Tablet.png' onCloseDialog={props.onCloseDialog} />
    </Dialog>
  )
}

export default ErrorDialog
